import { faqItems } from '@/mocks/animeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于51动漫的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-[800px] mx-auto flex flex-col gap-3 md:gap-4">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6 cursor-default"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-7 h-7 md:w-8 md:h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-primary-500 text-sm md:text-base font-heading">Q</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-2">
                    {item.q}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}